import slideToggle from '../../slideToggle'

// Toggles open and closed the list of related entitites on the Entity landing page on mobile.
const RelatedButton = (function () {
  // DOM elements
  const button = document.querySelector('.js-related-button')
  const contentBlock = document.querySelector('.js-related-content')

  const initRelatedButton = () => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      contentBlock.classList.toggle('c-related-entity-menu__groups--hidden')
      contentBlock.slideToggle({ duration: 250, display: 'flex' })
      button.toggleAttribute('aria-expanded')
    })
  }

  return {
    init: () => {
      if (button) {
        initRelatedButton()
      }
    },
  }
})()

export default RelatedButton
